import {
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  TextField,
  useMediaQuery,
  Typography,
} from "@mui/material";
import { Box, useTheme } from "@mui/system";
import { Colors } from "helpers/Consts";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import { useFormik } from "formik";
import * as Yup from "yup";
import { IAddUserParams } from "types/User";
import TelefoneTextField from "ui/TelefoneTextField";
import { useMutationRegisterUser } from "services/api/mutations/useMutationRegisterUser";
import { useSearchParams } from "react-router-dom";
import BirthDayField from "ui/BirthDayField";
import { Alert } from "@mui/lab";

type Props = {
  open: boolean;
  handleClose: () => void;
};
function CreateAccountDialog({ open, handleClose }: Props) {
  const { mutate: registerUser } = useMutationRegisterUser();
  const theme = useTheme();
  const [searchParams] = useSearchParams();
  const place_id = searchParams.get("place_id");
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      birth_date: "",
      email: "",
      name: "",
      password: "",
      confirmpassword: "",
      phone_number: "",
      phone_validated: false,
    } as IAddUserParams,
    validationSchema: Yup.object().shape({
      name: Yup.string()
        .required("Nome é obrigatório.")
        .min(3, "Nome está muito curto."),
      email: Yup.string()
        .email("Email não é um email valido.")
        .required("Email é obrigatorio"),
      password: Yup.string().required("Senha é obrigatório."),
      phone_number: Yup.string().required("Telefone é obrigatório."),
      confirmpassword: Yup.string().oneOf(
        [Yup.ref("password"), null],
        "Senhas não estão iguais."
      ),
    }),
    onSubmit: async (values) => {
      formik.setSubmitting(false);
      let user = handleUser();
      registerUser(user);
      handleClose();
      resetValues();
    },
  });
  const handleUser = (): IAddUserParams => {
    return {
      birth_date: formik.values.birth_date,
      email: formik.values.email,
      name: formik.values.name,
      password: formik.values.password,
      phone_number: formik.values.phone_number,
      place_id: Number(place_id!),
    } as IAddUserParams;
  };
  function resetValues() {
    formik.values.birth_date = "";
    formik.values.email = "";
    formik.values.name = "";
    formik.values.password = "";
    formik.values.confirmpassword = "";
    formik.values.phone_number = "";
    formik.values.phone_validated = false;
  }
  return (
    <Dialog
      fullScreen={fullScreen}
      open={open}
      onClose={() => {
        resetValues();
        handleClose();
      }}
      maxWidth={"lg"}
    >
      <DialogTitle color={Colors.orangePrimary}>
        <Box display="flex" alignItems="center">
          <Box>
            <IconButton
              color="primary"
              onClick={() => {
                resetValues();
                handleClose();
              }}
            >
              <ArrowBackIosIcon fill={Colors.orangePrimary} />
            </IconButton>
          </Box>
          <Box
            flexGrow={1}
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            Cadastre-se
          </Box>
        </Box>
      </DialogTitle>
      <DialogContent>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            width: { md: "600px" },
            height: "100%",
            paddingX: "8px",
          }}
        >
          <form noValidate onSubmit={formik.handleSubmit}>
            <Box>
              <Box
                sx={{
                  width: "100%",
                }}
              >
                <TextField
                  fullWidth
                  id="name"
                  label="Nome"
                  placeholder="Nome"
                  variant="standard"
                  type="text"
                  value={formik.values.name}
                  onChange={formik.handleChange}
                  required
                />
                <Box
                  sx={{
                    display: "flex",
                    marginTop: 2,
                  }}
                >
                  <TextField
                    fullWidth
                    id="password"
                    label="Senha"
                    placeholder="Senha"
                    variant="standard"
                    type="password"
                    sx={{
                      width: "50%",
                    }}
                    value={formik.values.password}
                    onChange={formik.handleChange}
                    required
                  />
                  <TextField
                    fullWidth
                    id="confirmpassword"
                    label="Confirmar Senha"
                    placeholder="Confirmar Senha"
                    variant="standard"
                    sx={{
                      width: "50%",
                      marginLeft: 1,
                    }}
                    type="password"
                    value={formik.values.confirmpassword}
                    onChange={formik.handleChange}
                    required
                  />
                </Box>
                <TextField
                  fullWidth
                  id="email"
                  label="Email"
                  placeholder="Email"
                  sx={{
                    marginTop: 2,
                  }}
                  variant="standard"
                  type="email"
                  value={formik.values.email}
                  onChange={formik.handleChange}
                  required
                />
                <Box
                  sx={{
                    display: "flex",
                    marginTop: 2,
                  }}
                >
                  <TelefoneTextField
                    id="phone_number"
                    onChange={formik.handleChange}
                    required
                    type="text"
                    value={formik.values.phone_number}
                    variant="standard"
                    sx={{
                      width: "50%",
                    }}
                    label="Telefone"
                  />
                  <BirthDayField
                    id="birth_date"
                    label="Data de Nascimento"
                    variant="standard"
                    sx={{
                      width: "50%",
                      marginLeft: 1,
                    }}
                    type="text"
                    value={formik.values.birth_date}
                    onChange={formik.handleChange}
                    required
                  />
                </Box>
                {/* {(formik.errors && formik.dirty) && (
                  <Alert
                    severity="warning"
                    sx={{
                      display: "flex",
                      flexGrow: 1,
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <Typography fontSize="14px" fontWeight={700}>
                      Erro na edição
                    </Typography>
                  </Alert>
                )} */}

                <Button
                  sx={{
                    width: "100%",
                    color: "white",
                    textTransform: "none",
                    marginTop: 2,
                  }}
                  type="submit"
                  variant="contained"
                  disabled={!(formik.isValid && formik.dirty)}
                >
                  Cadastre-se
                </Button>
              </Box>
            </Box>
          </form>
        </Box>
      </DialogContent>
    </Dialog>
  );
}

export default CreateAccountDialog;
